export default {
  site_name: 'MARKJY',
  site_subtitle: 'UnknownBox',
  site_tagline: '问号盒',
  home: 'Home',
  blog: 'Blog',
  contact: 'Contact',
  about: 'About',
  login: 'Login',
  signout: 'Sign Out',
  logout: 'Delete',
  register: 'Register',
  admin: 'Admin',
  theme_light: 'Light',
  theme_dark: 'Dark',
  language: 'Language',
  username: 'Username',
  password: 'Password',
  confirm_password: 'Confirm Password',
  old_password: 'Old Password',
  new_password: 'New Password',
  submit: 'Submit',
  cancel: 'Cancel',
  save: 'Save',
  edit: 'Edit',
  delete: 'Delete',
  reply: 'Reply',
  comment: 'Comment',
  comments: 'comments',
  no_comments: 'No comments yet',
  write_comment: 'Write a comment...',
  comment_placeholder: 'Enter comment...',
  comment_username_placeholder: 'Temporary username',
  comment_submit: 'Post Comment',
  comment_count: 'comments',
  reply_count: 'replies',
  load_more: 'Load More',
  no_posts: 'No posts yet',
  read_more: 'Read More',
  back_to_blog: 'Back to Blog',
  publish_date: 'Published on',
  update_date: 'Updated on',
  about_me: 'About Me',
  contact_me: 'Contact Me',
  github: 'GitHub',
  email: 'Email',
  website: 'Website',
  all_posts: 'All Posts',
  new_post: 'New Post',
  edit_post: 'Edit Post',
  post_title: 'Post Title',
  post_content: 'Post Content',
  manage_posts: 'Manage Posts',
  manage_comments: 'Manage Comments',
  change_password: 'Change Password',
  confirm_delete: 'Confirm delete?',
  login_success: 'Login successful',
  register_success: 'Registration successful',
  logout_confirm: 'Confirm logout?',
  password_rule: 'Password: 6-24 characters',
  username_rule: 'Username: min 1 Chinese char or 2 letters, max 14 Chinese chars',
  username_taken: 'Username is already registered',
  username_available: 'Username available',
  username_temp_taken: 'This username is already taken on this post',
  rate_limit: 'Too many comments, please try again in 10 minutes',
  not_found: 'Page not found',
  server_error: 'Server error',
  network_error: 'Network error',
  login_required: 'Please login first',
  admin_required: 'Admin access required',
  confirm_logout: 'Confirm logout? This will clear your login state.',
  logout_with_password: 'Logout (password confirmation required)',
  username_alphabetic_start: 'Username cannot start with a number',
  delete_account: 'Delete Account',
  delete_account_confirm: 'This action cannot be undone. Please enter your password to confirm:',
  profile: 'Profile',
  contact_content: 'Feel free to reach out via:',
  build_tool: 'Built with',
  delete_post_confirm: 'Are you sure you want to delete this post? All comments will also be deleted.',
  delete_comment_confirm: 'Are you sure you want to delete this comment?',
  image_upload: 'Upload Image',
  image_upload_fail: 'Image upload failed',
  copy_link: 'Copy Link',
  link_copied: 'Copied to clipboard',
  expand: 'Expand',
  collapse: 'Collapse',
  view_detail: 'View Detail',
  view_replies: 'View replies',
  hide_replies: 'Hide replies',
  write_reply: 'Write a reply...',
  lang_zh_CN: '简体中文',
  none: 'NULL',
  lang_zh_TW: '繁體中文',
  lang_en: 'English',
}
